<template>
    <v-dialog
    v-model="show"
    fullscreen
    >
   
    <div class="text-center" style="background-color: #353535; height: inherit;">
        <v-toolbar dense elevation="0">
            <v-spacer/>
             <v-btn small @click="emitToParent('close')"><v-icon left>mdi-close</v-icon>Close</v-btn>
        </v-toolbar>
        <div class="pa-2">
               <img :src="imgsrc"/>
        </div>
        
      </div>
  </v-dialog>
</template>

<script>
export default {
  props: {
      show:{
          type: Boolean,
          default: false
      },
      imgsrc: {
            type: String,
          default:''
      }
  },
  methods: {
   emitToParent (action) {
      this.$emit('DialogEvent', action)
    }
  }
}
</script>
